@let isRMMPE = permissionsEnum.RmmPerEndpoint | can: 'read';
@let isRMMCE = permissionsEnum.RmmCeEnabled | can: 'read';
@let hasHelpMarketing = 'HelpMarketing' | can: 'read';

<mbs-modal [title]="'shared:computers.connectionLicense.licenseRequired' | i18next">
  <ng-container modal-body>
    <mbs-alert [type]="alertType.info">
      @if (!isVNCorSSH) {
        {{ 'shared:computers.connectionLicense.licenseIsRequiredWeb' | i18next }}
      } @else {
        {{ 'shared:computers.connectionLicense.licenseIsRequiredSSHVNC' | i18next }}
      }
      @if (hasHelpMarketing) {
        <a
          href="/AP/Help/remote-management/connect/licensing"
          target="_blank">
          {{ 'shared:computers.connectionLicense.learnMore' | i18next }}
        </a>
      }
    </mbs-alert>
    <mbs-form-group>
      <mbs-radio
        [label]="'shared:computers.connectionLicense.useBackupLicense' | i18next"
        [subtitle]="'shared:computers.connectionLicense.selectOptionToConnectUsingWebBrowser' | i18next"
        [subtitleHide]="isUnix"
        [subtitleOutside]="false"
        [(ngModel)]="type"
        [descriptionOutside]="false"
        [value]="connectionLicenseType.Backup">
      </mbs-radio>
      <mbs-radio
        [label]="
          (isRMMPE
            ? 'shared:computers.connectionLicense.useConnectOrRMMPELicense'
            : 'shared:computers.connectionLicense.useConnectOrRMMLicense'
          ) | i18next
        "
        [subtitle]="
          (isRMMPE
            ? 'shared:computers.connectionLicense.selectOptionToConnectUsingWebBrowser'
            : 'shared:computers.connectionLicense.selectOptionToConnectToAllYourComputers'
          ) | i18next
        "
        [subtitleHide]="isUnix"
        [subtitleOutside]="false"
        [(ngModel)]="type"
        [descriptionOutside]="true"
        [value]="connectionLicenseType.RMM">
      </mbs-radio>
      @if (!isRMMPE && isRMMCE && (limitRMMCEExceeded$ | async) === false) {
        <mbs-radio
          [label]="'shared:computers.connectionLicense.useInstallRMMAgent' | i18next"
          [subtitle]="'shared:computers.connectionLicense.selectOptionToConnectToAllYourComputers' | i18next"
          [subtitleHide]="isUnix"
          [subtitleOutside]="false"
          [(ngModel)]="type"
          [descriptionOutside]="true"
          [value]="connectionLicenseType.InstallRMM">
        </mbs-radio>
      }
    </mbs-form-group>
    {{ 'shared:computers.connectionLicense.onceYouGrantRequiredLicense' | i18next }}
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="baseModal.save(type)">
      {{ 'shared:buttons.proceed' | i18next }}
    </mbs-button>
    <mbs-button (click)="baseModal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
